import React, { useState } from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import Video from "../components/video"

import AvatarImg from "../images/avatar-example.png"
import VideoImg from "../images/youtube.jpg"
import InterfaceImg from "../images/screenshot.png"

const CONTACT_EMAIL = "charles@supermanual.io"

const IndexPage = () => {
  const [videoVisible, setVideoVisible] = useState(false)

  return (
    <Layout>
      <SEO title="Virtual Exhibitions & Events" />
      <div className="header fixed w-full bg-white z-10">
        <div className="container flex justify-start align-start font-sansBold px-6 py-6">
          SuperManual&nbsp;<span className="text-red">Expo</span>
        </div>
      </div>

      <div className="px-6 pt-16 mb-12 md:mb-24 container">
        <h1 className="text-center text-3xl md:text-6xl font-sansBold mt-16 md:mt-24">
          Shift to a virtual event
        </h1>
        <p className="text-center mt-4 text-xl">
          Move ahead with your event swiftly and achieve real connections
          safely.
        </p>
      </div>

      <div className="px-6 py-6 mb-12 md:mb-24 container flex flex-col-reverse md:flex-row justify-around">
        <div className="w-full pl-0 md:pl-12 md:w-1/3">
          <h2 className="font-sansBold mb-4 text-xl">Virtual Expos</h2>
          <p className="mb-6">
            A new way connect people at your upcoming event, conference or expo.
            Create an experience with real presence; safely, securely, remotely
            and virtually.
          </p>
          <p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="bg-red hover:bg-lightRed text-white inline-block font-sansBold py-4 px-6 rounded-full"
            >
              Let’s talk about your event
            </a>
          </p>
        </div>
        <div className="w-full md:w-2/5 mb-12">
          <div className="relative pb-9/16 w-full">
            <button
              className="absolute h-full w-full object-cover bg-red outline-none focus:outline-none"
              onClick={e => setVideoVisible(true)}
            >
              <img src={VideoImg} alt="SuperManual Expo Preview" />
              <span className="play">
                <em>
                  <svg
                    width="15"
                    height="19"
                    viewBox="0 0 15 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6782 9.66071L0.213867 18.8214V0.5L14.6782 9.66071Z"
                      fill="white"
                    />
                  </svg>
                </em>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="bg-red mb-12 md:mb-24">
        <div className="px-6 py-8 md:py-12 container text-white text-center">
          Have questions? Connect with us via our{" "}
          <a
            href="http://slack.supermanual.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Slack
          </a>
          ,{" "}
          <a
            href="https://www.linkedin.com/company/supermanual/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            LinkedIn
          </a>{" "}
          or
          <a
            href="https://twitter.com/supermanual"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Twitter
          </a>
        </div>
      </div>

      <div className="px-6 mb-6 md:mb-24 container flex flex-wrap justify-around">
        <div className="w-full md:w-1/2 px-0 md:pr-24 mb-12">
          <p className="text-3xl md:text-6xl leading-none font-sansBold text-red mb-6 md:mb-12">
            What you’d expect from a real expo, but more.
          </p>
          <p className="mb-4">
            Under normal circumstances a good expo connects ideas to an engaged
            and motivated audience of business decision makers, investors,
            entrepreneurs.
          </p>
          <p className="mb-4 font-sansBold">
            These are not normal circumstances.
          </p>
          <p className="mb-4">
            This is an opportunity to create a real expo experience while
            unlocking the insights and potential only achievable with virtual
            tech.
          </p>
        </div>
        <div className="w-full md:w-1/2 px-0 md:px-24">
          <h3 className="mb-4 font-sansBold text-red">Real presence </h3>
          <p className="mb-4">
            Create your avatar, name badge and a message. With some with some
            virtual magic, exhibitors can explore the expo while also attending
            their booth, at the same time. You’ll be notified you when you have
            a visitor.
          </p>
          <h3 className="mb-4 font-sansBold text-red">Interact in real-time</h3>
          <p className="mb-4">
            While exploring, you meet new people, wave or swap business cards.
            You can message in real-time from anywhere in the expo, even if
            you’re not attending your booth.
          </p>
          <h3 className="mb-4 font-sansBold text-red">
            Conduct face-to-face business
          </h3>
          <p className="mb-4">
            If the interaction is going well you can connect and demonstrate
            with real value via video link. Using your dashboard you can manage
            multiple interactions at once while you’re also queueing up video
            calls.
          </p>
          <h3 className="mb-4 font-sansBold text-red">
            Insights on everything
          </h3>
          <p className="mb-4">
            By harnessing the power of virtual technology, exhibitors and
            delegates gain access to every insight from the entire event. Who
            and how many waved, visited your booth, swapped a card, look at your
            content, messaged and requested video links.{" "}
          </p>
        </div>
      </div>

      <div className="px-6 mb-12 md:mb-12 container flex flex-col-reverse md:flex-row justify-around">
        <div className="w-full md:w-1/2 px-0 md:pr-24  mb-12">
          <p className="text-4xl md:text-5xl leading-tight font-sansBold mb-12">
            Exhibitions, trade shows, fairs and conferences. Out-of-the-box or
            fully custom, we can move your event to virtual, now.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="bg-red hover:bg-lightRed text-white inline-block font-sansBold py-4 px-6 rounded-full"
          >
            Let’s talk about your event
          </a>
        </div>
        <div className="w-full md:w-7/12 px-0 md:px-12 mb-12">
          <img src={AvatarImg} alt="SuperManual Expo Avatar" />
        </div>
      </div>

      <div className="px-6 py-6 mb-6 container flex">
        <div className="text-2xl md:text-4xl leading-tight">Case</div>
      </div>

      <div className="px-6 mb-12 md:mb-12 container flex justify-around">
        <div>
          <h2 className="text-4xl md:text-6xl leading-tight font-sansBold mb-6 md:mb-6 text-center">
            QODE goes virtual
          </h2>
          <p className="text-center text-xl mb-6 md:mb-12">
            A world-first, post COVID-19, virtual expo event, made at blistering
            pace.
          </p>
          <div className="text-center">
            <div className="device">
              <img
                src={InterfaceImg}
                className="mb-0 block"
                alt="SuperManual Expo Interface"
              />
            </div>
          </div>
          {/* <div>
            <p className="text-center">
              Pictured: An animation of the virtual expo app UI that TB is
              working on.
            </p>
          </div> */}
        </div>
      </div>

      <div className="px-6 py-6 md-12 md:mb-24 container flex justify-center">
        <div className="w-full md:w-4/5">
          <p className="text-center text-xl md:text-2xl font-sansBold">
            "Working with QODE to go virtual was a great opportunity for us to
            help in these challenging times. Innovating to keep communities
            connected is now more important than ever before. It was a pleasure
            to see people coming together to share ideas safely, securely, and
            virtually in what might be the #newnormal ”
          </p>
          <p className="text-center">— Charles Henden, Technical Director</p>
        </div>
      </div>

      <div className="px-6 py-6 mb-12 md:mb-24 container flex flex-wrap justify-around">
        <div className="w-full md:w-1/2 px-0 md:pr-24">
          <p className="text-4xl md:text-5xl leading-tight font-sansBold mb-12">
            Shift your event to virtual. Now is the time to use innovation to
            keep communities connected.
          </p>
          &nbsp;
        </div>
        <div className="w-full md:w-1/2 px-0 md:px-24">
          <p className="mb-4">
            In a matter of weeks, Australia’s premier innovation and technology
            event QODE, turned the recent government COVID-19 directives for
            public events into an opportunity to present an entirely virtual
            event.
          </p>
          <p className="mb-4">
            Consolidated and streamed live on YouTube across two days, a global
            online audience engaged with world leading visionaries, pioneers and
            innovation drivers from their workplace, home or quarantine.
          </p>
          <p className="mb-4">
            Enter SuperManual, the team of technologists and creatives tasked
            with delivering a parallel virtual expo for exhibitors and delegates
            to immerse in and interact with company representatives and
            experience cutting-edge solutions and tech.
          </p>
          <p className="mb-4">
            The technical and organisational challenges of bringing together
            such an ambitious, concurrent, online experience in 10 days were met
            with long hours and many video chats!{" "}
          </p>
          {/* <p className="mb-4">
            The result was a genuine expo experience with 5,056 interactions,
            888 messages exchanged, 225 video chats, 324 business card swaps and
            1,747 waves.
          </p> */}
          <p className="font-sansBold">
            Shift your event to virtual. Now is the time to use innovation to
            keep communities connected.
          </p>
        </div>
      </div>

      <div className="footer text-white">
        <div className="px-6 pt-12 md:pt-24 pb-12 md:pb-24 container flex justify-center flex-wrap flex-col items-center">
          <p className="text-4xl md:text-5xl leading-tight text-center font-sansBold mb-12">
            Let’s get your event happening
          </p>
          <p className="font-sansBold mb-12 text-center">
            Tell us the details of your event and we will quote same-day.
          </p>
          <p className="mb-12">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="bg-white hover:bg-peach text-black inline-block font-sansBold py-4 px-6 rounded-full"
            >
              Contact Us
            </a>
          </p>

          <p className="flex mb-12">
            <a
              href="https://twitter.com/supermanual"
              rel="noopener noreferrer"
              target="_blank"
              className="inline-block px-2"
            >
              <svg height="21px" viewBox="0 0 25 21">
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="supermanual-"
                    transform="translate(-782.000000, -8384.000000)"
                    fill="#ffffff"
                  >
                    <path
                      d="M807,8386.39258 C806.304199,8387.44238 805.4375,8388.3335 804.44873,8389.05371 L804.44873,8389.7251 C804.44873,8396.5 799.297363,8404.3125 789.873535,8404.3125 C786.980469,8404.3125 784.258301,8403.67773 782,8402.2251 C782.402832,8402.28613 782.805664,8402.31055 783.220703,8402.31055 C785.613281,8402.31055 787.847168,8401.27295 789.580566,8399.88135 C787.358887,8399.85693 785.442383,8398.34326 784.807617,8396.31689 C785.125,8396.37793 785.442383,8396.41455 785.759766,8396.41455 C786.223633,8396.41455 786.6875,8396.35352 787.126953,8396.23145 C784.783203,8395.76758 783.013184,8393.69238 783.013184,8391.20215 L783.013184,8391.14111 C783.708984,8391.51953 784.490234,8391.75146 785.33252,8391.77588 C783.940918,8390.84814 783.037598,8389.28564 783.037598,8387.52783 C783.037598,8386.57568 783.306152,8385.79443 783.733398,8385.0376 C786.284668,8388.13818 790.044434,8390.06689 794.29248,8390.29883 C794.207031,8389.93262 794.182617,8389.51758 794.182617,8389.11475 C794.182617,8386.28271 796.465332,8384 799.297363,8384 C800.774414,8384 802.10498,8384.63477 803.069336,8385.61133 C804.216797,8385.37939 805.327637,8384.95215 806.304199,8384.36621 C805.925781,8385.5625 805.120117,8386.57568 804.045898,8387.21045 C805.095703,8387.08838 806.072266,8386.80762 807,8386.39258 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
              </svg>
            </a>
            <a
              href="https://au.linkedin.com/company/supermanual"
              rel="noopener noreferrer"
              className="inline-block px-2"
            >
              <svg height="25px" viewBox="0 0 26 25">
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="supermanual-"
                    transform="translate(-732.000000, -8381.000000)"
                    fill="#ffffff"
                  >
                    <g
                      id="Group-25"
                      transform="translate(732.000000, 8381.000000)"
                    >
                      <path
                        d="M6.75,3.38134766 C6.75,4.98046875 5.52929688,6.25 3.60058594,6.25 L3.56396484,6.25 C1.72070312,6.25 0.5,4.98046875 0.5,3.38134766 C0.5,1.77001953 1.74511719,0.524902344 3.64941406,0.524902344 C5.52929688,0.524902344 6.72558594,1.77001953 6.75,3.38134766 Z"
                        id="Path"
                      ></path>
                      <polygon
                        id="Path"
                        points="1.02490234 8.85009766 6.22509766 8.85009766 6.22509766 25 1.02490234 25"
                      ></polygon>
                      <path
                        d="M14.5625,15.625 L14.5625,25 L9.35009766,25 L9.35009766,12.5 C9.35009766,12.5 9.26464844,9.39941406 9.26464844,8.85009766 L14.3916016,8.85009766 L14.5625,11.0839844 C15.6000977,9.52148438 17.1625977,8.33740234 19.25,8.33740234 C22.8999023,8.33740234 25.5,10.9375 25.5,15.625 L25.5,25 L20.2875977,25 L20.2875977,16.1499023 C20.2875977,13.5375977 19.0180664,12.5 17.4555664,12.5 C15.8930664,12.5 14.5625,13.5375977 14.5625,15.625 Z"
                        id="Path"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/supermanual.io/"
              rel="noopener noreferrer"
              className="inline-block px-2"
            >
              <svg height="25px" viewBox="0 0 25 25">
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="supermanual-"
                    transform="translate(-826.000000, -8382.000000)"
                    fill="#ffffff"
                  >
                    <g
                      id="glyph-logo_May2016"
                      transform="translate(826.000000, 8382.000000)"
                    >
                      <path
                        d="M12.4528423,0.00785961443 C9.07083539,0.00785961443 8.64676223,0.0221947603 7.31853683,0.082797825 C5.99307958,0.143252595 5.08783984,0.353781513 4.29574889,0.661641127 C3.47686604,0.979831933 2.78240237,1.4056352 2.09006426,2.09792388 C1.39777558,2.79026199 0.971972318,3.48472565 0.653781513,4.3036085 C0.345921898,5.09569946 0.135392981,6.0009392 0.0749382106,7.32639644 C0.0143351458,8.65462185 0,9.07869501 0,12.4607019 C0,15.8426594 0.0143351458,16.2667326 0.0749382106,17.594958 C0.135392981,18.9204152 0.345921898,19.825655 0.653781513,20.6177459 C0.971972318,21.4366288 1.39777558,22.1310924 2.09006426,22.8234305 C2.78240237,23.5157192 3.47686604,23.9415225 4.29574889,24.2597627 C5.08783984,24.5675729 5.99307958,24.7781018 7.31853683,24.8385566 C8.64676223,24.8991597 9.07083539,24.9134948 12.4528423,24.9134948 C15.8347998,24.9134948 16.258873,24.8991597 17.5870984,24.8385566 C18.9125556,24.7781018 19.8177954,24.5675729 20.6098863,24.2597627 C21.4287692,23.9415225 22.1232328,23.5157192 22.8155709,22.8234305 C23.5078596,22.1310924 23.9336629,21.4366288 24.2519031,20.6177459 C24.5597133,19.825655 24.7702422,18.9204152 24.830697,17.594958 C24.8913,16.2667326 24.9056352,15.8426594 24.9056352,12.4607019 C24.9056352,9.07869501 24.8913,8.65462185 24.830697,7.32639644 C24.7702422,6.0009392 24.5597133,5.09569946 24.2519031,4.3036085 C23.9336629,3.48472565 23.5078596,2.79026199 22.8155709,2.09792388 C22.1232328,1.4056352 21.4287692,0.979831933 20.6098863,0.661641127 C19.8177954,0.353781513 18.9125556,0.143252595 17.5870984,0.082797825 C16.258873,0.0221947603 15.8347998,0.00785961443 12.4528423,0.00785961443 Z M12.4528423,2.25160652 C15.7778547,2.25160652 16.1717252,2.26431043 17.4848245,2.32422145 C18.6989619,2.37958478 19.3583292,2.5824518 19.797133,2.75299061 C20.3783984,2.97889273 20.7932279,3.2487395 21.2289669,3.68452793 C21.6647553,4.12026693 21.9346021,4.53509639 22.1605042,5.11636184 C22.331043,5.5551656 22.53391,6.21453287 22.5892734,7.42867029 C22.6491844,8.74176965 22.6618883,9.13564014 22.6618883,12.4607019 C22.6618883,15.7857143 22.6491844,16.1795848 22.5892734,17.4926841 C22.53391,18.7068216 22.331043,19.3661888 22.1605042,19.8049926 C21.9346021,20.386258 21.6647553,20.8010875 21.2289669,21.2368265 C20.7932279,21.6726149 20.3783984,21.9424617 19.797133,22.1683638 C19.3583292,22.3389026 18.6989619,22.5417696 17.4848245,22.597133 C16.1719229,22.657044 15.7781018,22.6697479 12.4528423,22.6697479 C9.12753337,22.6697479 8.73376174,22.657044 7.42081068,22.597133 C6.20667326,22.5417696 5.54730598,22.3389026 5.10850222,22.1683638 C4.52723678,21.9424617 4.11240732,21.6726149 3.67666831,21.2368265 C3.24092931,20.8010875 2.97103312,20.386258 2.74513099,19.8049926 C2.57459219,19.3661888 2.37172516,18.7068216 2.31636184,17.4926841 C2.25645082,16.1795848 2.24374691,15.7857143 2.24374691,12.4607019 C2.24374691,9.13564014 2.25645082,8.74176965 2.31636184,7.42867029 C2.37172516,6.21453287 2.57459219,5.5551656 2.74513099,5.11636184 C2.97103312,4.53509639 3.24087988,4.12026693 3.67666831,3.68452793 C4.11240732,3.2487395 4.52723678,2.97889273 5.10850222,2.75299061 C5.54730598,2.5824518 6.20667326,2.37958478 7.42081068,2.32422145 C8.73391003,2.26431043 9.12778052,2.25160652 12.4528423,2.25160652 Z"
                        id="Fill-1"
                      ></path>
                      <path
                        d="M12.4528423,16.6116164 C10.1603065,16.6116164 8.3018784,14.7531883 8.3018784,12.4607019 C8.3018784,10.1681661 10.1603065,8.30973801 12.4528423,8.30973801 C14.7453287,8.30973801 16.6037568,10.1681661 16.6037568,12.4607019 C16.6037568,14.7531883 14.7453287,16.6116164 12.4528423,16.6116164 Z M12.4528423,6.0659911 C8.92110727,6.0659911 6.05813149,8.92896688 6.05813149,12.4607019 C6.05813149,15.9923875 8.92110727,18.8553633 12.4528423,18.8553633 C15.9845279,18.8553633 18.8475037,15.9923875 18.8475037,12.4607019 C18.8475037,8.92896688 15.9845279,6.0659911 12.4528423,6.0659911 Z"
                        id="Fill-4"
                      ></path>
                      <path
                        d="M20.5945131,5.81334652 C20.5945131,6.63865546 19.9254572,7.30766189 19.1001483,7.30766189 C18.2748888,7.30766189 17.6058329,6.63865546 17.6058329,5.81334652 C17.6058329,4.98803757 18.2748888,4.31898171 19.1001483,4.31898171 C19.9254572,4.31898171 20.5945131,4.98803757 20.5945131,5.81334652"
                        id="Fill-5"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </p>

          <p>Copyright ©2020 SuperManual</p>
        </div>
      </div>

      <Video videoVisible={videoVisible} setVideoVisible={setVideoVisible} />
    </Layout>
  )
}

export default IndexPage
